import { useMemo } from 'react';

import { useOperations } from './useOperations';

export function useIsToolsReadOnly() {
  const { canUser } = useOperations();

  return useMemo(() => !canUser('manage_instructions'), [canUser]);
}
